import { NavLink } from 'react-router-dom';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import { useState } from 'react';

export default function Stage01() {
  return (
    <div>
      <Navigation />

      {/* <Banner src='/img/stage-01.jpg' classType='banner__image--other-01' /> */}
      <Banner src='/img/chandra-03.webp' classType='banner__image--top-01 banner--tiny' />

      <main className='stage01'>
        <NavLink to='/stages-et-retraites' className='retour'>
          <div className='retour__icon--down-arrow'>
            <img src='/icons/left-arrow.svg' alt='icone dun chevron' />
          </div>
          <p className='retour__text'>Retour à la liste</p>
        </NavLink>

        <h2 className='presentation__title heading-section color-black'>
          Chandra Yoga : Sérénité et puissance
        </h2>

        <p className='presentation__subtitle'>Harmonie du corps et de la conscience</p>

        <div className='infos u-margin-bottom-big'>
          <h3 className='infos__dates'>Du 6 au 8 Juin 2025</h3>
          <div className='infos__duree-et-prix'>3 jours / 2 nuits 310€ (270€ jusqu au 15 Mars)</div>
          <div className='seance__bottom--localisation localisation stage__localisation'>
            <div className='localisation__logo'>
              <img
                src='/icons/location.svg '
                alt='logo de localisation'
                className='localisation__logo1'
              />
            </div>
            <div className='localisation__lieu'>Juvigny Val d&apos;Andaine</div>
          </div>
        </div>

        <section className='bienfaits u-margin-bottom-big'>
          <h3 className='heading-sous-titre u-margin-bottom-medium bienfaits__sous-titre u-center-text'>
            Objectifs et bienfaits
          </h3>

          <p className='common-text bienfaits__list--element u-justify-text '>
            L&apos;objectif du stage « Chandra Yoga et corps conscient » est de permettre à chaque
            participant d&apos;expérimenter le corps conscient, espace dans lequel les perceptions
            sensorielles sont vécues dans la fraîcheur de l&apos;instant, sans l&apos;intervention
            du mental discursif. Dans cette expérience intime où le corps et la conscience sont
            inséparables, s&apos;élèvent des prises de conscience pouvant amener le pratiquant à un
            lâcher-prise. Là où le corps était tendu par les émotions et les pensées, la fluidité et
            la détente s&apos;installent. Au terme du stage, les participants pourront ressentir
            divers bienfaits tels qu&apos;une hausse du niveau d&apos;énergie, une conscience
            corporelle plus subtile, un apaisement du mental ainsi que la réduction des tensions et
            du stress.
          </p>
        </section>

        <section className='programme '>
          <h3 className='heading-sous-titre u-margin-bottom-medium programme__sous-titre u-center-text'>
            Méthode
          </h3>

          <p className='common-text bienfaits__list--element u-justify-text color-black'>
            Le corps conscient n&apos;est pas qu&apos;un concept : il doit être expérimenté à
            travers le vécu corporel. Dans cette optique, nous pratiquerons le Chandra Yoga en
            alternant entre les 17 mouvements et mantras de la série et des phases d&apos;accueil
            des sensations dans l&apos;immobilité. La première partie du stage se focalisera sur
            l&apos;apprentissage des 17 postures afin que chaque participant puisse intégrer les
            points clés de chacune d&apos;elles et s&apos;y dépose sans tensions superflues. La
            seconde partie sera consacrée à la répétition de la série dans son intégralité afin de
            maîtriser les transitions entre les postures tout en se laissant couler avec fluidité
            dans l&apos;enchaînement. En soirée la récitation assise des mantra permettra de
            s&apos;imprégner des vocables. Lors de la dernière partie du stage, nous associerons la
            récitation des mantras aux 17 mouvements de la série. Cette association pourra conduire
            à un vécu plus subtil de la pratique favorisant l&apos;arrêt du mental, la fluidité, la
            détente corporelle et une plus grande attention aux sensations. Dans toutes ces phases,
            à la fin d&apos; une série de mouvements, le corps demeure immobile et se dépose dans la
            posture tandis que le mental se dépose dans les sensations.
          </p>
        </section>

        <p className='common-text u-margin-bottom-big remarque my-special-common-text color-black'>
          *Les repas à tendances bio, végétariens et locaux et adaptés à la pratique sont compris
          dans le prix du stage.
        </p>

        <section className='tarifs-et-inscription u-margin-bottom-big'>
          <h2 className='presentation__title heading-section u-center-text color-black u-margin-bottom-big'>
            Tarifs & inscriptions
          </h2>
          <div className='tarifs-et-inscription__container'>
            <div className='tarifs-et-inscription__element'>
              <div className='tarifs-et-inscription__element--head'>
                <h3 className='heading-sous-sous-titre'>Inscription classique</h3>
                <p className='tarifs-et-inscription__element--head-price'>310€</p>
              </div>

              <div className='tarifs-et-inscription__element--middle'>
                🛌 Chambre individuelle ou partagée
                <br />
                ☀️ Hébergement 3 jours
                <br />
                🍽️ Repas inclus (tendance végétarien, bio, local, adaptée à la pratique du yoga et
                de la méditation)
              </div>

              <NavLink
                to={
                  'https://www.helloasso.com/associations/arkanhom/evenements/inscription-stage-de-chandra-yoga-et-corps-conscient'
                }
                className='tarifs-et-inscription__element--bottom btn btn--white'
              >
                Inscrivez-vous !
              </NavLink>
            </div>

            <div className='tarifs-et-inscription__element'>
              <div className='tarifs-et-inscription__element--head'>
                <h3 className='heading-sous-sous-titre'>Early birds</h3>
                <p className='tarifs-et-inscription__element--head-price'>270€</p>
              </div>

              <div className='tarifs-et-inscription__element--middle'>
                🛌 Chambre individuelle ou partagée
                <br />
                ☀️ Hébergement 3 jours
                <br />
                🍽️ Repas inclus (tendance végétarien, bio, local, adaptée à la pratique du yoga et
                de la méditation)
              </div>

              <NavLink
                to={
                  'https://www.helloasso.com/associations/arkanhom/evenements/inscription-stage-de-chandra-yoga-et-corps-conscient'
                }
                className='tarifs-et-inscription__element--bottom btn btn--white'
              >
                Inscrivez-vous !{' '}
              </NavLink>
            </div>
          </div>
        </section>

        <section className='le-lieu u-margin-bottom-big'>
          <h2 className='presentation__title heading-section color-black u-margin-bottom-small formateur-000'>
            Le lieu
          </h2>
          <p className='common-text u-margin-bottom-medium'>
            Un lien emprunt d&apos;histoire, chaleureux et accueillant pour nos groupes.
          </p>

          <Caroussel photos_caroussel_srcs={photos_caroussel_srcs} />
        </section>

        <section className='banner-en-savoir-plus u-margin-bottom-big'>
          <p className='u-margin-bottom-medium banner-en-savoir-plus__text'>
            Envie d&apos;en savoir plus sur les disciplines proposées lors de cette retraite?
            <br /> Découvrez nos articles
          </p>
          <div className='banner-en-savoir-plus__container'>
            <NavLink to={'/articles/'} className='btn-navlink'>
              Articles
            </NavLink>
          </div>
        </section>

        <section className='formateur u-margin-bottom-big'>
          <h2 className='presentation__title heading-section formateur-000'>Votre formateur</h2>
          <div className='formateur__details'>
            <img
              src='/img/stage-06.webp'
              alt='Formateur Antoine'
              className='formateur__details--img'
            />
            <div className='formateur__details--infos'>
              <h3 className='formateur__details--infos-name'>Antoine</h3>
              <p className='formateur__details--infos-text'>
                Fondateur & Enseignant certifié à l&apos;enseignement du Yoga
              </p>
            </div>
            <NavLink className={'btn-navlink btn-formateur'} to={'/qui-sommes-nous'}>
              En savoir plus
            </NavLink>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

const photos_caroussel_srcs = [
  '/img/image-arkanhom-02.jpg',
  '/img/image-arkanhom-01.jpg',
  '/img/image-110.jpg',
  '/img/chandra-02.jpg',
  '/img/thrulkhor-02.jpg',
];

function Bulle(props) {
  return (
    <div className={`bulle ${props.index === props.step ? 'bulle-active' : 'not-active'}`}></div>
  );
}

function Caroussel({ photos_caroussel_srcs }) {
  const [previousStep, setPreviousStep] = useState(0);
  const [step, setStep] = useState(1);
  const [nextStep, setNextStep] = useState(2);

  function handlePrevious(step) {
    setPreviousStep(previousStep === 0 ? photos_caroussel_srcs.length - 1 : previousStep - 1);
    setStep(step === 0 ? photos_caroussel_srcs.length - 1 : step - 1);
    setNextStep(nextStep === 0 ? photos_caroussel_srcs.length - 1 : nextStep - 1);
  }

  function handleNext(step) {
    setPreviousStep(previousStep === photos_caroussel_srcs.length - 1 ? 0 : previousStep + 1);
    setStep(step === photos_caroussel_srcs.length - 1 ? 0 : step + 1);
    setNextStep(nextStep === photos_caroussel_srcs.length - 1 ? 0 : nextStep + 1);
  }

  return (
    <div className='caroussel__container'>
      <div className='caroussel__images'>
        <img
          src='/icons/left-arrow.svg'
          alt=''
          className='caroussel__arrow--left'
          onClick={() => handlePrevious(step)}
        />
        <img
          src='/icons/left-arrow.svg'
          alt=''
          className='caroussel__arrow--right'
          onClick={() => handleNext(step)}
        />
        <img
          src={photos_caroussel_srcs[previousStep]}
          alt=''
          className='caroussel__images--image-1 caroussel__images--image'
        />
        <img
          src={photos_caroussel_srcs[step]}
          alt=''
          className='caroussel__images--image-2 caroussel__images--image'
        />
        <img
          src={photos_caroussel_srcs[nextStep]}
          alt=''
          className='caroussel__images--image-3 caroussel__images--image'
        />
      </div>
      <div className='caroussel__bubulle'>
        {photos_caroussel_srcs.map((src, index) => (
          <Bulle src={src} index={index} key={index} step={step} />
        ))}
      </div>
    </div>
  );
}
